import script from "./ViewApprovalMatrixDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewApprovalMatrixDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__